import { render, staticRenderFns } from "./SideBarC.vue?vue&type=template&id=8418c2ba&scoped=true"
import script from "./SideBarC.vue?vue&type=script&lang=ts"
export * from "./SideBarC.vue?vue&type=script&lang=ts"
import style0 from "./SideBarC.vue?vue&type=style&index=0&id=8418c2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8418c2ba",
  null
  
)

export default component.exports